import { Icon } from "@iconify/react";
import Button from "../../../../components/Button/Button";
import Table from "../../../../components/Table/Table";
import { useEffect, useState } from "react";
import Modal from "../../../../components/Modal";
import { TableSearch } from "../../../../components/Table/TableActions";

// Dummy Data
import StudenInfoData from "../../../../dummy_data/studentinfo.json";

const AcademicInformations = () => {
  const [currentRow, setCurrentRow] = useState({});
  const [searchResult, setSearchResult] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const columns = [
    {
      name: "Subject",
      selector: row => row?.subject
    },
    {
      name: "CA score",
      selector: row => row?.ca_score
    },
    {
      name: "Exam Score",
      selector: row => row?.exam_score
    },
    {
      name: "Total",
      selector: row => row?.total
    },
    {
      name: "Grade",
      selector: row => row?.grade
    },
    {
      name: "Date",
      selector: row => row?.date
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button className="table-action-icon">
            <Icon icon="nimbus:edit" />
          </button>
          <button onClick={handleDeleteModal}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    // The data will be from the inventory get api endpint
    setSearchResult(StudenInfoData);
  }, []);

  // --| Filter Shelf21 table using name, email and class
  const handleAdminSchools = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = StudenInfoData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                          data?.description
                                            ?.toLowerCase()
                                            .includes(word.toLowerCase()) ||
                                          data?.category
                                            ?.toLowerCase()
                                            .includes(word.toLowerCase()) ||
                                            data?.status
                                              ?.toLowerCase()
                                              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <div>
      <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
        <TableSearch placeholder="Search here..." searchTableFunc={handleAdminSchools} />
      }
      />
      {/* Delete Modal */}
      <Modal
        title="Delete Subject"
        subtitle={
          <div>Are you sure you want to delete subject <span className="modal-name-highlight">{currentRow?.staff_name}</span>.If subject is deleted, school will no longer have access to the subject information.`
          </div>}
        modalContent={
          <>

          </>
        }
        modalFooter={
          <>
            <div className="flex gap-10">
              <Button
                variant="dangeroutline"
                buttonSize="full"
                color="btndanger"
                buttonName="Cancel"
              />
              <Button variant="danger" buttonName="Delete Subject" buttonSize="full" color="btndefault" />
            </div>
          </>
        }
        isopen={deleteModal}
        closeModal={handleDeleteModal}
      />
    </div>
  );
};

export default AcademicInformations;
